import { Component, OnInit } from '@angular/core';
import { DataService } from '../../utils/data.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { generalService } from '../../services/general.service';
import { motivoDeCancelacion } from '../../models/factura';
@Component({
  selector: 'my-factura-eliminar',
  styles: [],
  templateUrl: './factura-eliminar.component.html',
  providers: [generalService]
})
export class FacturaEliminarComponent implements OnInit {

  mensaje: string = '';

  public motivosDeCancelacion : motivoDeCancelacion[] =[
    {idCancelacion:"01",description:"Comprobante emitido con errores con relación"},
    {idCancelacion:"02",description:"Comprobante emitido con errores sin relación"},
    {idCancelacion:"03",description:"No se llevó a cabo la operación"},
    {idCancelacion:"04",description:"Operación nominativa relacionada en una factura global"}
   ];
   public motivoCancelacion:string = "02";

  // Sustitución (Motivo "01"): UUID de la factura sustituta (FolioSustitución)
  public folioSustitucion: string = null;
  public sustitutaBillNumber: string = null;
  public autoResuelto: boolean = false;
  public listaDocumentoSustituta: any[] = [];
  public sustitutaSeleccionada: number = null;

  constructor(
    public dataService: DataService,
    private formBuilder: FormBuilder,
    private _generalService: generalService) {

  }

  ngOnInit() {

  }

  aceptar() {
    if (this.motivoCancelacion === '01' && (this.folioSustitucion === null || this.folioSustitucion === undefined || this.folioSustitucion === '')) {
      this._generalService.toastCall('Falta el UUID de la factura sustituta (FolioSustitución) para el motivo 01.');
      return;
    }
    this.cancelFactura();
  }

  cerrarModal() {
    this.dataService.dialogRef.close();
  }

  // Al cambiar el motivo: si es "01" (sustitución) se intenta resolver el UUID sustituto.
  onMotivoChange() {
    this.folioSustitucion = null;
    this.sustitutaBillNumber = null;
    this.autoResuelto = false;
    this.sustitutaSeleccionada = null;
    this.listaDocumentoSustituta = [];
    if (this.motivoCancelacion === '01') {
      this.resolverSustituta();
    }
  }

  // Auto-resolución: busca la factura sustituta a partir de la relación guardada (bill_docto_related).
  resolverSustituta() {
    const factura: any = { BILL_ID: this.dataService.id };
    this._generalService.metodoCallParams(factura, `factura/getUuidSustituta/`).subscribe(
      (result) => {
        const res = JSON.parse(result);
        if (res !== null && res !== undefined && res.length > 0 && res[0].UUID) {
          this.folioSustitucion = res[0].UUID;
          this.sustitutaBillNumber = res[0].BILL_NUMBER;
          this.autoResuelto = true;
        } else {
          this.autoResuelto = false;
          this.cargarSustitutasManual();
        }
      },
      (error) => {
        this.autoResuelto = false;
        this.cargarSustitutasManual();
      }
    );
  }

  // Fallback manual: lista de facturas timbradas del cliente para elegir la sustituta.
  cargarSustitutasManual() {
    const idCliente = this.dataService.factura.CUSTOMER_ID;
    if (idCliente === null || idCliente === undefined) {
      this.listaDocumentoSustituta = [];
      return;
    }
    this._generalService.metodoCall(`RecepcionPago/getDocumentos?CUSTOMER_ID=` + idCliente).subscribe(
      (result) => {
        const res = JSON.parse(result);
        if (res !== null && res !== undefined && res.length > 0) {
          // Excluir la propia factura que se está cancelando
          this.listaDocumentoSustituta = res.filter((d) => d.BILL_ID !== this.dataService.id);
        } else {
          this.listaDocumentoSustituta = [];
        }
      },
      (error) => {
        this.listaDocumentoSustituta = [];
      }
    );
  }

  // Selección manual de la sustituta: toma su UUID como FolioSustitución.
  onSelectSustitutaManual() {
    const doc = this.listaDocumentoSustituta.find((d) => d.BILL_ID === this.sustitutaSeleccionada);
    this.folioSustitucion = (doc !== undefined && doc !== null) ? doc.UUID : null;
    this.sustitutaBillNumber = (doc !== undefined && doc !== null) ? doc.BILL_NUMBER : null;
  }

  cancelFactura() {
    const loacs  = sessionStorage.getItem('acslo');
    const factura = {
      loacs: loacs,
      BILL_ID: this.dataService.id,
      idCompania: this.dataService.factura.idCompania,
      ORGANIZATION_ID: this.dataService.factura.idOrganizacion,
      UUID: this.dataService.factura.uuid,
      TOTAL: this.dataService.factura.TOTAL,
      //MOTIVO: this.dataService.factura.MOTIVO,
      MOTIVO: this.motivoCancelacion,
      //CUSTOMER_ID: this.dataService.factura.CUSTOMER_ID,
      CUSTOMER_ID: null,
      folioSustitucion: (this.motivoCancelacion === '01') ? this.folioSustitucion : null,
    };
    this._generalService.metodoCallParams(factura, `factura/cancel/`).subscribe(
          (result) => {
            this._generalService.toastCall('Se realizó la solcitud de cancelación exitosamente!');
            this.cerrarModal();
            },
          (error) => {
            console.log( error as any);
            this.cerrarModal();
          }
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/factura/consultar-eliminar/factura-eliminar.component.ts